<script lang="ts">
	import { run } from 'svelte/legacy';

	import { flyAndScale } from '$lib/animations';
	import IconCross from '$lib/icons/IconCross.svelte';
	import { createDialog, createSync, melt } from '@melt-ui/svelte';

	interface Props {
		closeButton?: boolean;
		open?: boolean;
		children?: import('svelte').Snippet;
		[key: string]: any
	}

	let { closeButton = true, open = $bindable(false), children, ...rest }: Props = $props();

	const {
		elements: { overlay, content, close, portalled },
		states,
	} = createDialog({
		role: 'dialog',
		forceVisible: true,
	});
	const { open: localOpen } = states;

	const sync = createSync(states);
	run(() => {
		sync.open(open, (x) => (open = x));
	});
</script>

<div class="" use:melt={$portalled}>
	{#if $localOpen}
		<div use:melt={$overlay} class="fixed inset-0 z-50 bg-black/50"></div>
		<div
			class="fixed left-[50%] top-[50%] z-50 translate-x-[-50%] translate-y-[-50%] rounded-md bg-white
             shadow-lg {rest.class}"
			transition:flyAndScale={{
				duration: 150,
				y: 8,
				start: 0.96,
			}}
			use:melt={$content}
		>
			{@render children?.()}

			{#if closeButton}
				<button
					use:melt={$close}
					type="button"
					aria-label="Close"
					class="absolute right-[10px] top-[10px] inline-flex h-6 w-6
                       appearance-none items-center justify-center rounded-full text-violet-800
                       hover:bg-violet-100 focus:shadow-violet-400"
				>
					<IconCross class="size-8"></IconCross>
				</button>
			{/if}
		</div>
	{/if}
</div>
